<template>
  <div>
    <v-menu
      v-model="isOpen"
      content-class="elevation-0"
      class="radius "
    >
      <template v-slot:activator="{ on, attrs, value }">
        <v-btn
          color="branche"
          class="btn-header"
          elevation="0"
          rounded
          :icon="$vuetify.breakpoint.mobile"      
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            class="--text-branche"   
            start           
          >
            {{ icon }} 
          </v-icon>
          <span
            v-if="!$vuetify.breakpoint.mobile"
            class="action text-truncate --text-branche"     
          >{{ libelleBtn }}</span>
          <v-icon
            v-if="!$vuetify.breakpoint.mobile"
            class="--text-branche"
          >
            {{ value ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
          <v-icon
            v-if="!isParametresExploitationComplet && isAdherentOrAdherentSelected"
            class="--text-branche"
            :class="$vuetify.breakpoint.mobile ? 'badge-param-mobile' : 'badge-param'"
          >
            mdi-information
          </v-icon>
        </v-btn>
      </template>
      <v-card
        elevation="2"
        class="mt-12"
      >
        <v-list
          v-for="(item, index) in items"
          :key="item.libelle"
          class="no-padding"
        >
          <v-list-item class="pa-0">
            <AgrButton
              block
              plain
              elevation="0"
              @click="onClick(item.code)"
            >
              <span
                class="action black--text"
              >{{
                item.libelle
              }}</span>
            </AgrButton>
          </v-list-item>
          <v-divider
            v-if="items.length > index + 1"
          />
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

import { AgrButton } from '@agrial/ui'

export default {
  name: 'BaseSelectUser',
  components: { AgrButton },
  props: {
    libelleBtn: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    isParametresExploitationComplet: {
      type: Boolean,
      default: false
    },
    isAdherentOrAdherentSelected: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {    
    onClick (param) {      
      this.$emit('onClick', param)
    }
  }
}
</script>

<style lang="scss" scoped>

.no-padding{
  padding: 0;
}

.v-list-item:hover {
  background-color: #e0e0e0 !important;
}

.badge-param {
  position: absolute;
  right: -20px;
  top: -20px;
}

.badge-param-mobile {
  position: absolute;
  right: -15px;
  top: -15px;
  font-size: 25px !important;
}
</style>
